import React, { useState } from "react";
import { Modal, Button, Form, Nav } from "react-bootstrap";

export default function AddContactModal({ show, setShow }) {
  const [activeTab, setActiveTab] = useState("basic");

  return (
    <Modal show={show} onHide={() => setShow(false)} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add New Contact</Modal.Title>
      </Modal.Header>

      {/* TABS */}
      <div className="px-3 pt-2">
        <Nav
          variant="tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="custom-tabs"
        >
          <Nav.Item><Nav.Link eventKey="basic">Basic Information</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link eventKey="address">Address</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link eventKey="social">Social Profiles</Nav.Link></Nav.Item>
          <Nav.Item><Nav.Link eventKey="access">Access</Nav.Link></Nav.Item>
        </Nav>
      </div>

      <Modal.Body>
        {activeTab === "basic" && (
          <>
            {/* UPLOAD */}
            <div className="upload-box text-center mb-4">
              <p className="fw-semibold">Upload Profile Image</p>
              <p className="small text-muted">Image should be below 4 mb</p>
              <Button size="sm" className="btn-orange me-2">Upload</Button>
              <Button size="sm" variant="light">Cancel</Button>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <Form.Label>First Name *</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Job Title *</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Company Name *</Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Phone Number *</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Phone Number 2 *</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Fax</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3 position-relative">
                <Form.Label>
                  Deals * <span className="add-new">+ Add New</span>
                </Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Date of Birth *</Form.Label>
                <Form.Control type="date" />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Ratings *</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Owner *</Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Industry *</Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Currency *</Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Label>Language *</Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>

              <div className="col-md-6 mb-3">
                <Form.Label>Tags *</Form.Label>
                <Form.Control defaultValue="Collab,Promotion,Rated,Davis" />
              </div>

              <div className="col-md-6 mb-3">
                <Form.Label>Source *</Form.Label>
                <Form.Select><option>Select</option></Form.Select>
              </div>
            </div>
          </>
        )}

        {activeTab === "address" && <div className="py-4 text-center">Address Tab</div>}
        {activeTab === "social" && <div className="py-4 text-center">Social Profiles</div>}
        {activeTab === "access" && <div className="py-4 text-center">Access</div>}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={() => setShow(false)}>
          Cancel
        </Button>
        <Button className="btn-orange">Save</Button>
      </Modal.Footer>

      <style>
        {`
        .btn-orange {
          background: #f26522;
          border: none;
        }

        .upload-box {
          border: 1px dashed #ddd;
          padding: 20px;
          border-radius: 8px;
          background: #fafafa;
        }

        .custom-tabs .nav-link.active {
          color: #f26522;
          border-bottom: 2px solid #f26522;
        }

        .add-new {
          color: #f26522;
          float: right;
          font-size: 12px;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #f26522;
          box-shadow: none;
        }
        `}
      </style>
    </Modal>
  );
}